export { default } from "./useStorageAccess";
export type { StorageAccessStatus } from "./useStorageAccess";
